export const mockAccountSummaryResponse = {
  accounts: [
    {
      accountId: '1fc7edc7-0a33-4c6b-86ad-d61bcd46a5fe1',
      last4Accountnumber: '9875',
      'cipher.firstName': 'Shanti',
      'cipher.lastName': 'Chaudhari',
      availableCredit: '3311.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '0.00',
      accountOpenDate: '2018-04-02',
      asOfDate: '2024-05-08',
      portfolio: null,
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'TJX Rewards Platinum Mastercard',
      isLeadAccount: true,
      clientId: 'tjx',
      portfolioLogo: 'https://www.synchrony.com/img/tjx_logo.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img072665.png',
      cardType: 'Mastercard®',
      isPended: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: true,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToTempShoppingPass: true,
        accessToTokenizedShoppingPass: true,
        accessToPlasticId: false,
      },
    },
    {
      accountId: '2fc7edc7-0a33-4c6b-86ad-d61bcd46a5fe1',
      last4Accountnumber: '9875',
      'cipher.firstName': 'Shanti',
      'cipher.lastName': 'Chaudhari',
      availableCredit: '3311.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '0.00',
      accountOpenDate: '2018-04-02',
      asOfDate: '2024-05-08',
      portfolio: null,
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'Lowes',
      isLeadAccount: false,
      clientId: 'lowes',
      portfolioLogo: 'https://www.synchrony.com/img/tjx_logo.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img072665.png',
      cardType: 'Mastercard®',
      isPended: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: true,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToTempShoppingPass: true,
        accessToTokenizedShoppingPass: true,
        accessToPlasticId: false,
      },
    },
    {
      accountId: '1fc7edc7-0a33-4c6b-86ad-d61bcd46a5fe2',
      last4Accountnumber: '9875',
      'cipher.firstName': 'Shanti',
      'cipher.lastName': 'Chaudhari',
      availableCredit: '3311.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '0.00',
      accountOpenDate: '2018-04-02',
      asOfDate: '2024-05-08',
      portfolio: 'chevron',
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'Chevron',
      isLeadAccount: true,
      clientId: 'paysol',
      portfolioLogo: 'https://www.synchrony.com/img/chevron_logo.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img072665.png',
      cardType: 'Visa®',
      isPended: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: true,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToTempShoppingPass: true,
        accessToTokenizedShoppingPass: true,
        accessToPlasticId: false,
      },
    },
    {
      accountId: 'f2c30d81-29cf-4f81-a7f3-69c2ba3ce0fd',
      last4Accountnumber: '8516',
      'cipher.firstName': 'SINGH',
      'cipher.lastName': 'GITA',
      availableCredit: '3450.00',
      creditLimit: '4200.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '5200.00',
      accountOpenDate: '2024-02-06',
      asOfDate: '2024-05-08',
      portfolio: null,
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'myWalgreens Mastercard',
      clientId: 'verizon',
      portfolioLogo:
        'https://www.mysynchrony.com/img/wag_signature_logo_rgb.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img056385.png',
      cardType: 'Mastercard',
      isPended: false,
      isLeadAccount: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToTempShoppingPass: true,
        accessToTokenizedShoppingPass: true,
        accessToPlasticId: false,
      },
    },
    {
      accountId: '821f2c70-1998-4a53-997c-c0dc8bd5f30e',
      last4Accountnumber: '0574',
      'cipher.firstName': 'SINGH',
      'cipher.lastName': 'GITA',
      availableCredit: '4300.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '1040.00',
      accountOpenDate: '2024-10-04',
      asOfDate: '2024-05-08',
      portfolio: 'CareCredit',
      productType: 'DUAL_CARD',
      lineOfBusiness: 'PAYMENT_SOLUTIONS_CARECREDIT',
      displayName: 'CARECREDIT REWARDS MASTERCARD',
      clientId: 'verizon',
      portfolioLogo:
        'https://www.mysynchrony.com/sites/mysyf/img/care-credit-logo-template.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img066242.png',
      cardType: 'Mastercard',
      isPended: true,
      isLeadAccount: true,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: true,
      },
    },
  ],
};

export const mockAccountSummaryNoLeadAccountResponse = {
  accounts: [
    {
      accountId: '1fc7edc7-0a33-4c6b-86ad-d61bcd46a5fe3',
      last4Accountnumber: '9875',
      'cipher.firstName': 'Shanti',
      'cipher.lastName': 'Chaudhari',
      availableCredit: '3311.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '0.00',
      accountOpenDate: '2018-04-02',
      asOfDate: '2024-05-08',
      portfolio: null,
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'TJX Rewards Platinum Mastercard',
      isLeadAccount: false,
      clientId: 'tjx',
      portfolioLogo: 'https://www.synchrony.com/img/tjx_logo.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img072665.png',
      cardType: 'Mastercard',
      isPended: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: true,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
      },
    },
    {
      accountId: 'f2c30d81-29cf-4f81-a7f3-69c2ba3ce0fd',
      last4Accountnumber: '8516',
      'cipher.firstName': 'SINGH',
      'cipher.lastName': 'GITA',
      availableCredit: '3450.00',
      creditLimit: '4200.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '5200.00',
      accountOpenDate: '2024-02-06',
      asOfDate: '2024-05-08',
      portfolio: null,
      productType: 'DUAL_CARD',
      lineOfBusiness: 'RETAIL_CARD',
      displayName: 'myWalgreens Mastercard',
      clientId: 'verizon',
      portfolioLogo:
        'https://www.mysynchrony.com/img/wag_signature_logo_rgb.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img056385.png',
      cardType: 'Mastercard',
      isPended: false,
      isLeadAccount: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
      },
    },
    {
      accountId: '821f2c70-1998-4a53-997c-c0dc8bd5f30e',
      last4Accountnumber: '0574',
      'cipher.firstName': 'SINGH',
      'cipher.lastName': 'GITA',
      availableCredit: '4300.00',
      creditLimit: '5000.00',
      currentBalance: '0.00',
      temporaryCreditLimit: '0.00',
      availableCashLimit: '1040.00',
      accountOpenDate: '2024-10-04',
      asOfDate: '2024-05-08',
      portfolio: 'CareCredit',
      productType: 'DUAL_CARD',
      lineOfBusiness: 'PAYMENT_SOLUTIONS_CARECREDIT',
      displayName: 'CARECREDIT REWARDS MASTERCARD',
      clientId: 'verizon',
      portfolioLogo:
        'https://www.mysynchrony.com/sites/mysyf/img/care-credit-logo-template.png',
      cardArtURL:
        'https://consumercenter.mysynchrony.com/cs/groups/public/documents/cc_images/img066242.png',
      cardType: 'Mastercard',
      isPended: true,
      isLeadAccount: false,
      showAccountDetails: false,
      features: {
        accessToAppleWallet: true,
        accessToGoogleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
      },
    },
  ],
};
